define(
	'C3.ShoppingExtensions.PDP.MakeAnOffer.CustomerCategory.Model',
	[
		'SCModel',
		'Utils'
	],
	function(SCModelComponent, Utils){
		'use strict';

		var SCModel = SCModelComponent.SCModel;

		function MakeAnOfferCustomerCategoryModel() {
			SCModel.call(this);

			// Define properties of the model.
			this.urlRoot = function() {
				return Utils.getAbsoluteUrl(
					getExtensionAssetsPath("services/MakeAnOffer.CustomerCategory.Service.ss")
				)
			}
		}

		MakeAnOfferCustomerCategoryModel.prototype = Object.create(SCModel.prototype);

		MakeAnOfferCustomerCategoryModel.prototype.constructor = MakeAnOfferCustomerCategoryModel;

		// Return the AMD constructor.
		return MakeAnOfferCustomerCategoryModel;
	}
);
